import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {Field, reduxForm} from "redux-form";
import {Box, Grid} from "@mui/material";
import _ from "lodash";
import {currentPage} from "_constants";
import {userInviteActions} from "_actions";
import {required, validatePassword} from "_helpers";
import {usePasswordStatusRedirect} from "../UserManagement/Utilities/hooks/usePasswordStatusRedirect";
import BasicFormTextField from "../../common/BasicFormTextField";
import ActionButton from "../../common/ActionButton";
import AnchorButton from "../../common/AnchorButton";
import PasswordGroup from "./Utilities/PasswordGroup";
import {Loading, SnackBar} from "../../../common";
import {validatePasswordMatch} from "./Utilities/userUtils";

function CreatePassword({handleSubmit}) {
    usePasswordStatusRedirect(currentPage.CREATE_PASSWORD);

    const dispatch = useDispatch();
    const passwordCreate = useSelector((state) => state.userInvite.passwordCreate);
    const loadingPasswordCreate = passwordCreate?.loading;

    const passwordStatus = useSelector((state) => state.userInvite.passwordStatus);
    const loadingPasswordStatus = passwordStatus?.loading;

    const handleCreatePassword = (values) => {
        if(_.isEmpty(values)) return;
        const error = validatePasswordMatch(values);
        if (error) {
            SnackBar.showMessage(error);
            return;
        }
        dispatch(userInviteActions.createPassword({password: values?.password}));
    };

    if(loadingPasswordStatus){
        return <Loading/>
    }

    return(
        <Box sx={styles.rootWrapper}>
            <Box sx={styles.container}>
                <Box component={"h1"} sx={styles.headingText}>Create Password</Box>

                <form name="form" onSubmit={handleSubmit(handleCreatePassword)} autoComplete="off">
                    <Grid container sx={{marginTop: { xs: '20px', sm: '25px', }}}>
                        <Grid item sx={styles.formContainer} xs={12} md={6} lg={4}>
                            <Box mb={{xs: "10px", sm: "10px", md: "15px", lg: "15px"}}>
                                <Box sx={styles.inputDesc}>Password</Box>
                                <Field
                                    name="password"
                                    placeholder={"Enter password"}
                                    component={PasswordGroup}
                                    validate={validatePassword}
                                />
                            </Box>
                            <Box mb={{xs: "15px", sm: "15px", md: "20px", lg: "20px"}}>
                                <Box sx={styles.inputDesc}>Confirm Password</Box>
                                <Field
                                    type="password"
                                    name="confirmPassword"
                                    placeholder="Confirm password"
                                    component={BasicFormTextField}
                                    validate={required}
                                />
                            </Box>

                            <Box sx={styles.footer}>
                                <Box sx={{width: '100px'}}>
                                    <ActionButton
                                        label={'Save'}
                                        disabled={loadingPasswordCreate}
                                    />
                                </Box>
                                <Box sx={{width: '100px'}}>
                                    <AnchorButton
                                        label={'Cancel'}
                                        link={'/profile'}
                                        buttonBordered={true}
                                    />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </form>

            </Box>
        </Box>
    )
}

const styles = {
    rootWrapper: {
        backgroundColor: '#edede4',
        pt: '135px',
        pb: 10,
        minHeight: '100vh',
    },
    container: {
        px: { xs: 2, sm: 6 },
        maxWidth: '1440px',
        position: 'relative',
        marginTop: '-2px'
    },
    headingText: {
        m: 0,
        fontFamily: 'IvyPrestoHeadlineRegular',
        fontSize: '35px',
        lineHeight: 0.8,
        color: '#0C2728',
        letterSpacing: '0.03em'
    },
    formContainer: {
        backgroundColor: '#FFF',
        border: '1px solid #CED4D4',
        borderRadius: '10px',
        padding: '20px'
    },
    inputDesc: {
        fontFamily: 'FustatSemiBold',
        fontSize: '14px',
        fontWeight: 500,
        color: '#003300',
        mb: '7px'
    },
    footer: {
        display: 'flex',
        gap: '18px'
    },
}


const formConfig = {
    form: 'CreatePasswordForm',
};

CreatePassword = reduxForm(formConfig)(CreatePassword)
export default CreatePassword